import { useState } from 'react';
import {Form, InputNumber,Select, Tabs } from 'antd'
import classes from './web.module.css'
import './aboutTable.css'; 
import Bread from '../cpn/Bread';
import WebMain from './WebMain';

function Dianshangtaizhang() {  
    const [userCount, setUserCount] = useState(1);
    const [yearCount, setYearCount] = useState(1);
    const [price, setPrice] = useState(50);
    const [storageType, setStorageType] = useState('1'); // 1: 公有云, 2: 私有云

    // 计算价格
    const calculatePrice = (users, years, type) => {
        // 如果是私有云，固定价格为2500元
        if (type === '2') {
            return 3000;
        }
        
        let unitPrice = 20; // 默认1年价格
        
        // 根据年限确定单价
        switch(years) {
            case 2:
                unitPrice = 16;
                break;
            case 3:
                unitPrice = 14;
                break;
            case 4:
                unitPrice = 12;
                break;
            case 5:
                unitPrice = 10;
                break;
            default:
                unitPrice = 20;
        }
        
        return users * unitPrice * years;
    };

    // 处理存储类型变化
    const handleStorageTypeChange = (key) => {
        setStorageType(key);
        setPrice(calculatePrice(userCount, yearCount, key));
    };

    // 处理用户数变化
    const handleUserCountChange = (value) => {
        setUserCount(value);
        setPrice(calculatePrice(value, yearCount, storageType));
    };

    // 处理年限变化
    const handleYearChange = (value) => {
        setYearCount(value);
        setPrice(calculatePrice(userCount, value, storageType));
    };

    // 公有云Tab内容
    const publicCloudContent = (
        <Form
            labelCol={{span:9}}
            wrapperCol={{span:15}}
            style={{width:"350px",border:"1px solid #dddddd",padding:"30px"}}                                    
        >
            <h3 style={{textAlign:"center",marginBottom:"30px"}}>价格计算器</h3>
            <Form.Item label='用户数'>
                <InputNumber 
                    min={1} 
                    defaultValue={1}
                    onChange={handleUserCountChange}
                />
            </Form.Item>
            <Form.Item label='购买年限'>
                <Select
                    options={[
                        {
                            label:"购买5年,50元/用户",
                            value:5,
                        },
                        {
                            label:"购买4年,48元/用户",
                            value:4,
                        },
                        {
                            label:"购买3年,42元/用户",
                            value:3,
                        },
                        {
                            label:"购买2年,36元/用户",
                            value:2,
                        },
                        {
                            label:"购买1年,20元/用户",
                            value:1,
                        },                      
                    ]}
                    defaultValue={5}
                    onChange={handleYearChange}
                />
            </Form.Item>                                   
            <Form.Item label='价格'>
                <h2>￥{price.toFixed(2)}</h2>
            </Form.Item>
        </Form>
    );

    // 私有云Tab内容
    const privateCloudContent = (
        <div style={{width:"350px",border:"1px solid #dddddd",padding:"30px",backgroundColor:"#f9f9f9"}}>
            <h3 style={{textAlign:"center",marginBottom:"30px"}}>私有云说明</h3>
            <div style={{lineHeight:"1.8",color:"#666"}}>
                <p><strong>数据存储方式：</strong></p>
                <p>私有云数据存储在企业自己的服务器上，提供更高的数据安全性和控制权。</p>
                <p><strong>价格：</strong></p>
                <p>私有云版本固定价格：<strong style={{color:"#1890ff",fontSize:"18px"}}>￥3000.00</strong></p>
                <p><strong>特点：</strong></p>
                <ul style={{marginLeft:"20px"}}>
                    <li>数据完全自主控制</li>
                    <li>用户数量不限</li>
                    <li>使用年限不限</li>
                    <li>更高的安全性</li>
                </ul>
            </div>
        </div>
    );

    return (
        <WebMain selectedKeys=''>
            <div style={{padding:'30px',display:"flex",flexDirection:"column",backgroundColor:"#eee"}}>
                <Bread text='电商台账'/>                
                <div className={classes.aboutItem3}>
                    <div  className={classes.softItem}>
                        <div style={{display:'flex',justifyContent:"space-between"}}>
                            <div style={{display:"flex"}}>
                                <div style={{padding:"70px"}}>
                                    <img src='/api/assets/images/application/1756454470_02e934bc1499127edebc.png' alt='' width={200}/>
                                </div>
                                <div style={{paddingTop:"30px",}}>
                                    <h1>电商台账</h1>
                                    <div>一款针对旅行社电商业务销售台账的管理软件，简洁高效。</div>
                                    <div style={{marginTop:"20px"}}><b>计调：</b>记录每笔电商业务的支出。</div>
                                    <div><b>客服：</b>记录每笔电商业务的收入。</div>
                                    <div><b>主播：</b>查看直播室的销售利润。</div>
                                    <div><b>财务：</b>审核销售台账。</div>
                                    <div><b>老板：</b>查询销售台账的网店利润、产品利润和销售人员利润。</div>
                                </div>
                            </div>
                            <div style={{padding:"40px 70px",}}>
                                <div>
                                    <Tabs
                                        defaultActiveKey="1"
                                        onChange={handleStorageTypeChange}
                                        items={[
                                            {
                                                key: '1',
                                                label: '公有云',
                                                children: publicCloudContent,
                                            },
                                            {
                                                key: '2',
                                                label: '私有云',
                                                children: privateCloudContent,
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{backgroundColor:"#eeeeee",padding:"30px"}}>
                            
                            <div><b>购买方式：</b>请登录淘宝网<a>点击打开</a>或者京东商城<a>前往</a></div>
                        </div>
                    </div>                    
                </div>                               
            </div>
        </WebMain>
    )
}

export default Dianshangtaizhang